import React from "react";
import style from "./NotFound.module.css";

const NotFound = () => {
  return (
    <div>
      <h1 className={style.NotFound}>Opps!! The page you are looking that not found !</h1>
    </div>
  );
};

export default NotFound;
